import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import TopBarHeader from '@/domains/mobile-web/components/TopBarHeader/TopBarHeader';
import HeaderMobile from '@/shared/components/ui/HeaderMobile/HeaderMobile';
import WrapperMobile from '@/shared/components/layout/WrapperMobile/WrapperMobile';
import CardWallet from '@/domains/mobile-web/components/CardWallet/CardWallet';
import CardWithdrawAmount from '@/domains/mobile-web/components/CardWithdrawAmount/CardWithdrawAmount';
import CardBankAccount, { type BankAccount } from '@/domains/mobile-web/components/CardBankAccount/CardBankAccount';
import { Info } from 'lucide-react';
import BottomPayment from '@/domains/mobile-web/components/BottomPayment/BottomPayment';
import { bankIcon } from '@/domains/mobile-web/constant/bank.constant';
import { usePayoutAccounts } from '@/domains/mobile-web/hooks/useBanks';
import type { PayoutAccount } from '@/domains/mobile-web/types/bank.types';
import { showToast } from '@/shared/utils/showToast';

const BALANCE = 840000

const toBankAccount = (account: PayoutAccount): BankAccount => ({
    id: account.id,
    bankName: account.bank_name ?? account.bank_code,
    accountNumber: account.account_number,
    // No name while the account could not be checked with DOKU
    accountHolder: account.account_holder ?? '-',
    logo: bankIcon(account.bank_code),
})

const formatPrice = (price: number) => new Intl.NumberFormat('id-ID').format(price);

const Withdraw = () => {
    const navigate = useNavigate()
    const payoutAccounts = usePayoutAccounts()
    const [amount, setAmount] = useState(0)
    const [selectedAccountId, setSelectedAccountId] = useState<string | undefined>()
    const bankAccounts = (payoutAccounts.data?.rows ?? []).map(toBankAccount)
    // Newest first, so a just-added account is the one picked
    const selectedAccount = bankAccounts.find((acc) => acc.id === selectedAccountId) ?? bankAccounts[0]

    useEffect(() => {
        if (payoutAccounts.isError) {
            showToast({ type: 'error', title: 'Gagal memuat rekening', message: payoutAccounts.error.message })
        }
    }, [payoutAccounts.isError, payoutAccounts.error])



    return (
        <main className='min-h-screen'>
            <HeaderMobile>
                <TopBarHeader type='back' title='Tarik Saldo' onBack={() => navigate(-1)} />
            </HeaderMobile>
            <WrapperMobile className='mb-[120px]'>
                <CardWallet income={BALANCE} />
                <CardWithdrawAmount
                    value={amount}
                    onChange={setAmount}
                    maxAmount={BALANCE}
                />
                <CardBankAccount
                    accounts={bankAccounts}
                    selectedId={selectedAccount?.id}
                    onSelect={(account) => setSelectedAccountId(account.id)}
                    onAddAccount={() => navigate('/store/bank')}
                />

                <div className="shadowCard p-3 flex flex-col gap-3">
                    <h3 className='title2medium text-black'>Rincian Penarikan</h3>
                    <div className="inline-flex gap-3 justify-between items-baseline flex-wrap">
                        <span className='reg12 text-text-grey'>Rekening Tujuan</span>
                        <span>
                            {selectedAccount ? `${selectedAccount.bankName} - ${selectedAccount.accountNumber}` : '-'}
                        </span>
                    </div>
                    <div className="inline-flex gap-3 justify-between items-baseline flex-wrap">
                        <span className='reg12 text-text-grey'>Jumlah Penarikan</span>
                        <span>Rp {formatPrice(amount)}</span>
                    </div>
                    <div className="inline-flex gap-3 justify-between items-baseline flex-wrap">
                        <span className='reg12 text-text-grey'>Biaya Admin</span>
                        <span>Gratis (Rp 0)</span>
                    </div>
                    <div className="border-blue-cs-200 border-[0.5px]"></div>
                    <div className=" title1bold text-black inline-flex gap-3 justify-between items-baseline flex-wrap">
                        <span className=''>Total Bayar</span>
                        <span>Rp {formatPrice(amount)}</span>
                    </div>
                    <div className="bg-text-blue-10 rounded-[8px] inline-flex px-3 py-1 gap-3 ">
                        <Info className='text-text-blue-100' />
                        <span className='body2medium'>Proses transfer paling lambat <strong>2x24 jam kerja</strong>  ke rekening tujuan pilihan anda.</span>
                    </div>
                </div>
            </WrapperMobile>
            <BottomPayment
                textButton='Tarik Komisi'
                title='Total Diterima'
                stylePrice='text-[#01724C]'
                onClick={() => alert('bayarCoy')}
                totalPrice={amount}
            />
        </main>
    )
}

export default Withdraw
